import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useT } from '../i18n';
import { trackEvent } from '../lib/track';

// Thin site-wide announcement strip that sits above the header (mounted in
// Layout.jsx). Framed as a coupon that's ALREADY applied — "coupon activated,
// start your story" — which pulls harder than a plain discount: the buyer feels
// they already own the saving and just needs to use it. The regular price is
// struck through, the discounted price shown, plus the amount saved. No
// countdown by design: on a trust-sensitive kids' gift a ticking clock reads as
// cheap dropshipping and costs more trust than the urgency buys.
//
// Clicking scrolls down to the category picker (#categories on Home) so the
// buyer lands straight on "start building your story". Off the Home page we
// route home first, then scroll once the (async-loaded) section mounts. Counts
// as a promo_click in the admin Stats, same as the other banners.
const OLD_PRICE = 299;
const NEW_PRICE = 249;
const SAVINGS = OLD_PRICE - NEW_PRICE;

// Home renders #categories only after /api/categories resolves, so after a
// route change the anchor may not exist on the first frame — poll briefly.
function scrollToCategories(attempt = 0) {
  const el = document.getElementById('categories');
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else if (attempt < 20) {
    setTimeout(() => scrollToCategories(attempt + 1), 100);
  }
}

export default function TopPromoBar() {
  const t = useT();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const onClick = () => {
    trackEvent('promo_click', { slug: 'top-bar', name: 'top-bar' });
    if (pathname === '/') {
      scrollToCategories();
    } else {
      navigate('/');
      scrollToCategories();
    }
  };

  return (
    <button type="button" className="top-promo-bar" aria-label={t.topBarAria} onClick={onClick}>
      <span className="top-promo-inner">
        <span className="top-promo-reason">🎟️ {t.topBarReason}</span>
        <span className="top-promo-prices">
          <span className="top-promo-old">{OLD_PRICE}₪</span>
          <span className="top-promo-new">{NEW_PRICE}₪</span>
        </span>
        <span className="top-promo-save">{t.topBarSave.replace('{amount}', SAVINGS)}</span>
        <span className="top-promo-cta">{t.topBarCta} ←</span>
      </span>
    </button>
  );
}
